import { createMuiTheme } from "@material-ui/core/styles";

const theme = createMuiTheme({
  typography: {
    fontFamily: ['"Montserrat"', "sans-serif"].join(","),
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 700 },
    fontWeightBold: 700,
    fontWeightLight: 400,
    fontWeightMedium: 600,
    fontWeightRegular: 500,
  },
  overrides: {
    MuiOutlinedInput: {
      root: {
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
           borderColor: "#ee3638",
        },
      }
    },
    MuiInputLabel: {
      root: {
        "&.Mui-focused": {
           color: "#ee3638",
        },
        marginLeft: 8
      },
    },
    MuiButton: {
      root: {
        textTransform: "capitalize",
      },
      containedPrimary: {
          backgroundColor: "#075AAA"
      }
    },
    MuiSvgIcon: {
      root: {
        color: "white"
      }
    },
    MuiTab: {
      textColorPrimary: {
        "&.Mui-selected": {
           color: "#ee3638",
        },
      }
    },
    MuiTableCell: {
      root: {
        padding: 8
      }
    }
  },
  palette: {
    type: "dark",
    primary: {
      main: "#01295C",
     },
    secondary: {
      main: "#ee3638",
    },
    background: {
      default: "#01295C",
      paper: "#010e24",
    },
  },
});

export default theme;
